/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CategoryDto from './CategoryDto';

/**
 * The PaginatedCategoriesDto model module.
 * @module model/PaginatedCategoriesDto
 * @version v0
 */
class PaginatedCategoriesDto {
    /**
     * Constructs a new <code>PaginatedCategoriesDto</code>.
     * @alias module:model/PaginatedCategoriesDto
     */
    constructor() { 
        
        PaginatedCategoriesDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PaginatedCategoriesDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PaginatedCategoriesDto} obj Optional instance to populate.
     * @return {module:model/PaginatedCategoriesDto} The populated <code>PaginatedCategoriesDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PaginatedCategoriesDto();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('limit')) {
                obj['limit'] = ApiClient.convertToType(data['limit'], 'Number');
            }
            if (data.hasOwnProperty('totalPages')) {
                obj['totalPages'] = ApiClient.convertToType(data['totalPages'], 'Number');
            }
            if (data.hasOwnProperty('totalElements')) {
                obj['totalElements'] = ApiClient.convertToType(data['totalElements'], 'Number');
            }
            if (data.hasOwnProperty('categories')) {
                obj['categories'] = ApiClient.convertToType(data['categories'], [CategoryDto]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PaginatedCategoriesDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PaginatedCategoriesDto</code>.
     */
    static validateJSON(data) {
        if (data['categories']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['categories'])) {
                throw new Error("Expected the field `categories` to be an array in the JSON data but got " + data['categories']);
            }
            // validate the optional field `categories` (array)
            for (const item of data['categories']) {
                CategoryDto.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} page
 */
PaginatedCategoriesDto.prototype['page'] = undefined;

/**
 * @member {Number} limit
 */
PaginatedCategoriesDto.prototype['limit'] = undefined;

/**
 * @member {Number} totalPages
 */
PaginatedCategoriesDto.prototype['totalPages'] = undefined;

/**
 * @member {Number} totalElements
 */
PaginatedCategoriesDto.prototype['totalElements'] = undefined;

/**
 * @member {Array.<module:model/CategoryDto>} categories
 */
PaginatedCategoriesDto.prototype['categories'] = undefined;






export default PaginatedCategoriesDto;

